import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const AnimatedQuestionBlock = ({
  key,
  heading=null,
  content=null,
  buttonText=null,
  buttonLink=null,
  openNewTab=false,
  questionSlides=null
}) => {
  return (
    <div className="animated-questions-block">
      <div className="container">
        <div className="col-12 col-lg-6 col-xl-5 offset-xl-1 animated-questions-content">
          {heading &&
            <h2 className={ `content-title ${content ? "orange-dash" : ""}` }>{ htmlDecode(heading) }</h2>
          }
          {content &&
            <div className="section-content" dangerouslySetInnerHTML={{ __html: content }} />
          }
          <div className="btn-row d-flex">
            {buttonText && buttonLink &&
              <Link href={ buttonLink } target={ `${openNewTab ? "_blank" : "_self"}` } className="button inverse mr2">{ buttonText }</Link>
            }
          </div>
        </div>
      </div>
      <div className="col-12 col-xl-6 offset-1 offset-lg-none content-col">
        <div className="content-inner col-12">
          {questionSlides && questionSlides.map((question) => (
            <div className="question-slide" dangerouslySetInnerHTML={{ __html: question.text }} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default AnimatedQuestionBlock
